import React from 'react';
import { Icon } from '../../../../elements/icon';
import useCopy from '../useCopy';
import { PLANS, GIFT_VALUES, SHIPPING_VALUE, fmtEur, fmtPct } from '../data/carouselLogic';
import { PRODUCT_SHOTS, GIFT_IMAGES } from '../assets';

const LOCKED_GIFTS = ['bag', 'container', 'guide', 'tracker'];

export const OfferSlide = ({ planKey }) => {
  const c = useCopy();
  const plan = PLANS[planKey];
  const sub = plan.subscription;
  const shown = sub ? plan.gifts : LOCKED_GIFTS;
  const vars = { savePct: fmtPct(c.lang, plan.discount), kitEur: fmtEur(c.lang, plan.kit) };

  return (
    <div className="s-offer">
      <div className="offer-top">
        <h2 className="offer-head">{c.variantRich('PC_Offer_Headline', planKey, vars)}</h2>
        <p className="offer-sub">{c.variantText('PC_Offer_Sub', planKey)}</p>
      </div>
      <div className="offer-main">
        <img className="pc-img offer-shot" alt="" src={PRODUCT_SHOTS[planKey]} />
        <div className="offer-side">
          <p className="offer-gtitle">{c.variantText('PC_Offer_GiftsTitle', planKey)}</p>
          <div className={`offer-gifts ${sub ? '' : 'locked'}`}>
            {shown.map((k) => (
              <div className="gift" key={k}>
                <div className="gift-img">
                  <img className="pc-img gift-pic" alt="" src={GIFT_IMAGES[k]} />
                  {!sub && (
                    <span className="gift-lock">
                      <Icon raw name="productCarouselLock" />
                    </span>
                  )}
                </div>
                <div className="gift-txt">
                  <b>{c.text(`PC_Gift_${k}`)}</b>
                  <span className="gift-price">
                    <s>{fmtEur(c.lang, GIFT_VALUES[k])}</s>
                    {sub && ` ${c.text('PC_Offer_Free')}`}
                  </span>
                </div>
              </div>
            ))}
          </div>
          {sub && (
            <p className="offer-ship">
              <s>{fmtEur(c.lang, SHIPPING_VALUE)}</s> {c.text('PC_Offer_Ship')}
            </p>
          )}
        </div>
      </div>
      <div className={`offer-strip ${sub ? '' : 'plain'}`}>
        {sub && <Icon raw name="productCarouselCheck" />}
        <span>{c.variantText('PC_Offer_Strip', planKey)}</span>
      </div>
    </div>
  );
};
